import React from 'react';
import { useSelector } from 'react-redux';
import { getItemAbsolutePoints } from 'app/core/markers/bounds';
import { getProjectState } from 'app/stores/project';
import { ProjectActions } from 'app/stores/project/actions';
import { useAppDispatch } from 'app/stores/store';
import { Edit } from './Edit';
export const HandleIds = {
    start: 'start',
    end: 'end',
};
export const createHandles = (marker) => {
    const [start, end] = getItemAbsolutePoints(marker);
    return {
        [HandleIds.start]: {
            current: start.toObject(),
        },
        [HandleIds.end]: {
            current: end.toObject(),
        },
    };
};
export const EditTwoPoints = () => {
    const marker = useSelector(state => {
        const project = getProjectState(state);
        const selectedItemId = project.selection[0];
        if (!selectedItemId) {
            return undefined;
        }
        return project.markers[selectedItemId];
    });
    const dispatch = useAppDispatch();
    const onHandleChanged = React.useCallback((handleId, point, _downPoint, initial) => {
        if (!marker) {
            return;
        }
        let patch;
        const { id } = marker;
        const [start, end] = getItemAbsolutePoints(marker);
        switch (handleId) {
            case HandleIds.start:
                patch = {
                    id,
                    patch: {
                        x: point.virtual.x,
                        y: point.virtual.y,
                        endX: end.x - point.virtual.x,
                        endY: end.y - point.virtual.y,
                    },
                };
                break;
            case HandleIds.end:
                patch = {
                    id,
                    patch: {
                        endX: point.virtual.x - start.x,
                        endY: point.virtual.y - start.y,
                    },
                };
                break;
            default:
                break;
        }
        if (patch) {
            dispatch(ProjectActions.itemUpdate(Object.assign(Object.assign({}, patch), { undoable: initial })));
        }
    }, [marker, dispatch]);
    return (React.createElement(Edit, { handles: createHandles(marker), onHandleChanged: onHandleChanged }));
};
